import { Typography } from '@mui/material';
import type { TypographyProps } from '@mui/material';
const BodyRegular = ({
  children,
  ...rest
}: TypographyProps) => {
  return <Typography typography='bodyRegular__Wallfund' {...rest} data-sentry-element="Typography" data-sentry-component="BodyRegular" data-sentry-source-file="BodyRegular.tsx">
      {children}
    </Typography>;
};
export default BodyRegular;